module.exports = __webpack_public_path__ + "static/media/technique2.9121abef.jpeg";